<!-- 标题 -->
<template>
    <div v-if="componentsData.type == 4">
        <div :style="`background: ${componentsData.content.bg_color};text-align: ${componentsData.content.position};`">
            <span :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`">
                {{ componentsData.content.text }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
</style>